<template>
	<div
		:class="classes" class="v-contextual v-contextual--menu">
		<slot name="primary">
		</slot>
		<slot :disabled="isDisabled" :processing="processing" :toggle="toggle" name="trigger">
			<div
				@click.prevent="click()"
				@mouseleave.prevent.stop="mouseleave()"
				@mouseenter.prevent.stop="mouseenter()">
				<process-button
					:id="triggerId" :aria-controls="menuId" :aria-expanded="on" :class="triggerClasses"
					:disabled="isDisabled"
					:processing="processing"
					:processingText="processingText"
					:text="text" aria-haspopup="true" class="v-contextual__trigger icon"
				/>
			</div>
		</slot>
		<ul
			v-show="on"
			:id="menuId"
			:aria-hidden="!on"
			:aria-labelledby="triggerId"
			:style="styles"
			class="v-contextual__options"
			role="menu"
			@mouseenter="preventTimeout()"
			@mouseleave="mouseleave()">
			<slot :menu="this"/>
		</ul>
	</div>
</template>
<script>
export default {
	data() {
		return {
			options: {},
			numberOfOptions: 0,
			on: false,
			timeout: null,
			styles: {},
			scrollHandler: null,
		};
	},

	computed: {
		classes() {
			return {
				"v-contextual--content--on": this.on,
				"v-contextual--disabled": this.isDisabled,
				"v-contextual--empty": !this.numberOfOptions,
				"v-contextual--menu--has-primary": !!this.$slots.primary,
			};
		},
		slots() {
			return this.$slots;
		},
		triggerClasses() {
			return {
				"v-contextual__trigger--on": this.on,
			};
		},
		isDisabled() {
			return this.disabled || !this.numberOfOptions;
		},
		menuId() {
			return "v-contextual__options--" + this.id;
		},
		triggerId() {
			return "v-contextual__trigger--" + this.id;
		},
	},

	props: {
		id: {
			type: String,
			default() {
				return String(this._uid);
			},
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
		showWithNoOptions: {
			type: Boolean,
			default() {
				return false;
			},
		},
		processing: {
			type: Boolean,
			default() {
				return false;
			},
		},
		toggleOnHover: {
			type: Boolean,
			default() {
				return false;
			},
		},
		text: {
			required: false,
			type: String,
			default() {
				return "Options";
			},
		},
		processingText: {
			required: false,
			type: String,
			default() {
				return "Processing";
			},
		},
	},

	methods: {
		addOption(option) {
			this.options[option._uid] = option;
			this.numberOfOptions = Object.keys(this.options).length;
		},
		removeOption(option) {
			this.$delete(this.options, option._uid);
			this.numberOfOptions = Object.keys(this.options).length;
		},
		toggle() {
			this.on = !this.on;
			this.setPosition();
			this.$emit("toggled", this.on);
		},
		click() {
			if (this.toggleOnHover) {
				return;
			}

			this.toggle();
		},
		mouseenter() {
			if (!this.toggleOnHover) {
				return;
			}

			this.preventTimeout();

			this.show();
		},
		mouseleave(immediate = false) {
			if (!this.toggleOnHover) {
				return;
			}

			if (!immediate) {
				this.timeout = setTimeout(() => {
					this.hide();
				}, 150);
				return;
			}

			clearTimeout(this.timeout);
			this.timeout = null;
			this.hide();
		},
		preventTimeout() {
			clearTimeout(this.timeout);
			this.timeout = null;
		},
		show() {
			this.on = true;
			this.setPosition();
		},
		hide() {
			this.on = false;
		},
		hideOnClickOutside(event) {
			if (this.$el.contains(event.target)) {
				return;
			}
			this.hide();
		},
		setPosition() {
			if (!this.on) {
				return;
			}

			this.$set(this.styles, "top", (this.$el?.getBoundingClientRect().top + this.$el?.getBoundingClientRect().height) + "px");
			this.$set(this.styles, "right", (window.innerWidth - this.$el?.getBoundingClientRect().right) + "px");
		},
		preventScroll(e) {
			if (!this.on) {
				return;
			}
			e.preventDefault();
		},
		// scrollHandler: new _.debounce(function () {
		// 	this.setPosition();
		// }, 1000),
	},

	mounted() {
		// this.scrollHandler = _.debounce(() => {
		// 	this.setPosition();
		// }, 1000);
		this.scrollHandler = (event) => {
			// this.preventScroll(event);
			this.setPosition();
		};
		window.addEventListener("scroll", this.scrollHandler, true);
		window.addEventListener("click", this.hideOnClickOutside);
	},

	destroyed() {
		window.removeEventListener("scroll", this.scrollHandler, true);
		window.removeEventListener("click", this.hideOnClickOutside);
	},
};
</script>
<style scoped>
.v-contextual__options {
	position: fixed;
}
</style>
